export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-color/src/math.js